import {
	ItemsOrderByDirection,
	type ItemsQuery,
	ItemsQueryOperator,
	ItemsQueryRuleOperator,
} from "@mondaydotcomorg/api";
import { NOTIFICATIONS_COLUMNS } from "@onesolution/constants/monday/notifications";
import type { Context } from "@onesolution/middlewares";
import { ALL_MONDAY_SCHEMAS, type MONDAY_TYPES } from "@onesolution/monday";
import { gql } from "graphql-request";
import { mondayClient } from "../monday";
import { requestAndFormat } from "../utils";

async function makeNotifsFilter(context: Context, onlyNotProcessed?: boolean) {
	const userRaw = await mondayClient.query.userInfoByEmail(
		context,
		context.user.email,
	);

	if (!userRaw)
		throw `Can't find current user details. Check monday's user's list ${context.user.email}`;

	return {
		rules: [
			{
				column_id: NOTIFICATIONS_COLUMNS.userIds,
				compare_value: [userRaw.id],
				operator: ItemsQueryRuleOperator.ContainsText,
			},
		].concat(
			onlyNotProcessed
				? [
						{
							column_id: NOTIFICATIONS_COLUMNS.processed,
							compare_value: [userRaw.id],
							operator: ItemsQueryRuleOperator.NotContainsText,
						},
					]
				: [],
		),
		order_by: [
			{ column_id: "__creation_log__", direction: ItemsOrderByDirection.Desc },
		],
		operator: ItemsQueryOperator.And,
	} as ItemsQuery;
}

export const notificationsQuery = async (
	context: Context,
	params: {
		queryParams?: ItemsQuery;
		onlyNotProcessed?: boolean;
		columnIds?: object;
	},
) =>
	requestAndFormat(
		{
			defaultParams: {
				boardId: context.boards?.notifications,
				columnIds: [
					NOTIFICATIONS_COLUMNS.boardId,
					NOTIFICATIONS_COLUMNS.processed,
					NOTIFICATIONS_COLUMNS.pulseId,
					NOTIFICATIONS_COLUMNS.time,
					NOTIFICATIONS_COLUMNS.userIds,
				],
				queryParams: await makeNotifsFilter(context, params.onlyNotProcessed),
				limit: 500,
			},
			gql: gql`
                query GetItemsPagesByValues(
                    $boardId: ID!,
                    $columnIds: [String!]!,
                    $limit: Int,
                    $queryParams: ItemsQuery
                ) {

                    boards(ids: [$boardId]) {
                        items_count
                        items_page(limit: $limit, query_params: $queryParams) {
                            cursor
                            items {
                                id
                                name
                                column_values(ids: $columnIds) {
                                    ${ALL_MONDAY_SCHEMAS}

                                    ... on BoardRelationValue {
                                        display_value
                                    }
                                }
                            }
                        }
                    }
                }
                `,
			resultKey: "boards[0].items_page.items",
			outType: [] as (MONDAY_TYPES["base"] & {
				boardId: MONDAY_TYPES["text"];
				processed: MONDAY_TYPES["text"];
				pulseId: MONDAY_TYPES["text"];
				time: MONDAY_TYPES["text"];
				userIds: MONDAY_TYPES["text"];
			})[],
		},
		params,
	);
